import React from 'react';
import { Utils } from 'poly-js-utils';
import { addQueryParam } from '../helpers';

export const DateTimeRange = ({start, end}) => (
    <p className="hs-event__date-time-range">
        {start}
        {end && " - " + end}
    </p>
);

export const RSVPTel = ({text, link, labelRsvp, eventName, className}) => (
    <div className={className}>
        <strong>{labelRsvp}: </strong>
        <a
            href={link}
            className="contact-link color-accent hs-event__contact-phone"
            data-click-type="event-rsvp"
            data-event-name={eventName}
        >
            {text}
        </a>
    </div>
);

export const RSVPLink = props => {
    const {
        link,
        labelRsvpButton,
        linkType,
        eventName,
        slug,
        is_external_url_with_reference,
        className
    } = props;

    const extendedLink = linkType === 'link' && is_external_url_with_reference ?
        addQueryParam(link, 'referenceId', slug) : link;

    return (
        <a
            href={extendedLink}
            target={linkType !== 'form' ? '_blank' : ''}
            rel="noopener"
            className={className || `btn btn-hs hs-event__contact-${linkType}`}
            data-click-type="event-rsvp"
            data-event-name={eventName}
        >
            {labelRsvpButton}
        </a>
    );
};

export const formatEventLink = function({ rsvpType, rsvpInfo, eventId, baseLink }) {
    let link;
    switch (rsvpType) {
        case ("email"):
            link = "mailto:" + rsvpInfo;
            break;
        case ("link"):
            link = Utils.makeAbsolute(rsvpInfo);
            break;
        case ("phone"):
            link = "tel:" + Utils.stripNonDigits(rsvpInfo);
            break;
        case ("form"):
            link = `${baseLink}events/?event=${eventId}#contact-form`;
            break;
        default:
            break;
    }
    return link;
};



// WEBPACK FOOTER //
// ./components/events_common/index.jsx